import { combineReducers } from '@ngrx/store';
import * as fromBlkOrder from './order.reducer';

export interface BlkSummaryState {
  blkOrderState: fromBlkOrder.BlkOrderState;
}

export const reducers = combineReducers({
  blkOrderState: fromBlkOrder.orderReducer,
});
